import React, {Component} from 'react';
import {Switch, Route} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import RfiList from "./RfiList";
import RfiNew from "./RfiNew";
import Rfi from "./Rfi";

class Rfis extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>RFIs</title>
        </Helmet>
        <Switch>
          <Route component={RfiUi}/>
        </Switch>
      </div>
    );
  }
}

const RfiUi = () => (
  <div>
    <Route exact path="/projects/:id/rfis/" component={RfiList}/>
    <Switch>
      <Route path="/projects/:id/rfis/new" component={RfiNew}/>
      <Route path="/projects/:id/rfis/:rfiId" component={Rfi}/>
    </Switch>
  </div>
);

export default withBreadcrumb(
  ({ match }) => ({ title: 'RFIs', path: `/projects/${match.params.id}/rfis/`}),
  Rfis
);




// WEBPACK FOOTER //
// ./src/components/Projects/Rfis/Rfis.js